<script lang="ts">
  export let size: number = 25;
  export let speed: number = 750;
  export let light: boolean = false;

  // true to hide (visiblity: hidden, not display: none, the intention being to avoid jarring
  // reflows). 'hidden' is taken by a global class because sad.
  export let hide = false;
</script>

<img
  class="spinner"
  class:light
  class:hide
  src="static/assets/icons/icon-loading.svg"
  height={size}
  width={size}
  alt="loading"
  style={`animation-duration:${speed}ms`}
/>

<style>
  .hide {
    visibility: hidden;
  }

  .spinner {
    transition-property: transform;
    animation-name: spin-infinite;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
  }

  .light {
    filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(93deg) brightness(103%) contrast(103%);
  }

  @keyframes spin-infinite {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
</style>
